import React, { useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap } from 'react-icons/fi';
import { Link } from 'react-router-dom';


import { MdError } from 'react-icons/md';

import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';
import Input from '../../../components/Forms/Input';
import Button from '../../../components/Forms/Button';
import Loader from '../../../components/Loader';
import MaskedInput from '../../../components/Forms/MaskedInput';
import { ResponseMessage } from '../../../components/ResponseMessage';
import getValidationErrors from '../../../utils/getValidationErrors';
import { Error } from './styles';
import SelectSimple from '../../../components/Forms/SelectSimple';
import Whatsapp from '../../../components/WhatsAppCompartilhar';

import api from '../../../services/api';
import { recaptchaKey } from '../../../config';
import getCep from '../../../services/cep';
import TextareaInput from '../../../components/Forms/TextareaInput';
import { useModal } from '../../../hooks/Modal';
import { useToast } from '../../../hooks/Toast';
import StarInput  from '../../DashboardPages/core/components/Forms/StarInput'  ;
import RangeInput from '../../DashboardPages/core/components/Forms/RangeInput';

import Sponsor from '../../Sponsors';
import { FaLink, FaLinkedin } from 'react-icons/fa';

interface IRecoverFormData {
  name: string;
  email: string;
  password: string;
  phone: string;
  captcha: string;
  birth_date: string;
}

interface ICaptcha {
  getValue(): string;
}

interface IProps {
  id : number;
}

const FormContainer : React.FC<IProps> = ({ id }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [knowAbout, setKnowAbout] = useState('');
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(false);
  const {removeModal} = useModal();
  const formRef = useRef<FormHandles>(null);
  const recaptchaRef = useRef(null);
  const {addToast} = useToast();


  const [position,setPosition] = useState(1);

  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };


  const handleNewLogin = async (data: IRecoverFormData) => {
    setLoading(true);

    data.birth_date = data.birth_date
      ? data.birth_date.toString().replace(/[^0-9/]/g, '')
      : '';

    try {
      formRef.current?.setErrors({});

      const shape = {
        p1: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p2: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p3: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p4: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p5: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p6: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p7: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p8: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p9: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p10: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p12: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p13: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
        p14: Yup.string().required('Por favor, responda a pergunta todas as perguntas'),
   
      };

      if( knowAbout === 'Outro' || knowAbout === 'redes sociais'){
        shape['p11'] = Yup.string().required('Por favor, responda a pergunta todas as perguntas');
      }

      const schema = Yup.object().shape(shape);

      await schema.validate(data, { abortEarly: false });

      const captchaValue =
        getCaptchaValue(recaptchaRef?.current || { getValue: () => '' }) ||
        false;

      const response = await api.post(`/send-research`, {
        ...data,
        client_id : id
      });

      removeModal('research');
      addToast({ title: 'Pesquisa de satisfação enviada', description: 'Você já pode acessar seu certificado!', type: 'success'})
      setLoading(false);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (formRef && formRef.current && formRef.current.setErrors) {
          formRef.current.setErrors(errors);
        }
        setLoading(false);

        const errorsString = Object.keys(errors).reduce(
          (prev: Array<string>, key: string): Array<string> => {
            prev = [...prev, errors[key]];
            return prev;
          },
          [],
        );

        setErrorMessage(errorsString);

        return;
      }

      setErrorMessage([
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          'Erro ao cadastrar sua pesquisa',
      ]);
    }
    setLoading(false);
  };

  {/* 
  
              <SelectSimple name="p1" label="" options={[
              { label: '0', value: '0'},
              { label: '1', value: '1'},
              { label: '2', value: '2'},
              { label: '3', value: '3'},
              { label: '4', value: '4'},
              { label: '5', value: '5'},
              { label: '6', value: '6'},
              { label: '7', value: '7'},
              { label: '8', value: '8'},
              { label: '9', value: '9'},
              { label: '10', value: '10'},
            ]}/>
 
 
          */         }


  return (
    <>
      {loading === true && (
        <Loader message="Carregando..." position="fixed" />
      )}

      <aside>

          <Form ref={formRef} onSubmit={handleNewLogin} initialData={{p15:'Sim'}}>
           
          <aside className='box' style={{display: position === 1 ? 'flex' : 'none'}}>
          <h2 style={{width:'100%', textAlign:'center', fontSize:'24px', color: "#333"}}>Formulário Avaliação de Satisfação	</h2>

            <br/><br/><p style={{margin: '10px auto', fontSize: '14px', maxWidth: '500px', color: "#333"}}>O objetivo deste instrumento é recebermos a sua percepção sobre o evento, identificando as suas necessidades, buscando sempre a melhoria contínua. Queremos saber a sua opinião sobre os seguintes tópicos: palestrantes, conteúdo, organização e avaliação geral. O período de preenchimento é até o dia 1º de junho. Sua opinião é muito importante para nós. 				
</p>

<button  type="button" onClick={() => setPosition(state => state + 1)} className='defaultButton'>INICIAR</button>
</aside>

<aside className='box' style={{display: (position >=2 && position <= 7) ? 'flex' : 'none'}}>
           <strong style={{margin: '10px 0px', maxWidth: '500px', color: "#333", fontSize: '12px'}}> Dê uma nota de 1 a 5 (sendo 5 a nota máxima), para as seguintes perguntas:</strong>


            <strong style={{color: "#333", textAlign:'center', marginTop: '20px', marginBottom: '10px', fontWeight: 'bold'}}> 
             PALESTRANTES</strong>
            </aside>

            <aside className='box' style={{display: (position >= 2 && position <= 3) ? 'flex' : 'none'}}>  
            <p style={{color: "#333", textAlign:'center', marginTop: '10px', marginBottom: '10px', fontWeight: 'bold'}}> 
            1.1- Em relação ao palestrante Dr. Alexandre Pagnoncelli
            </p>
            </aside>

            <aside className='box' style={{display: position === 2 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} placeholder="Esclarecimentos de dúvidas" name='p1'/>
            </aside>

            <aside className='box' style={{display: position === 3 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} placeholder="Linguagem clara e objetiva" name='p2'/>
            </aside>
            <aside className='box' style={{display: (position >= 4 && position <= 5) ? 'flex' : 'none'}}> 
            <p style={{color: "#333", textAlign:'center', marginTop: '10px', marginBottom: '10px', fontWeight: 'bold'}}> 
            1.2- Em relação ao palestrante Dr. Ronaldo Carissimi
            </p>
            </aside>

            <aside className='box' style={{display: position === 4 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} placeholder="Esclarecimentos de dúvidas" name='p3'/>
            </aside>
            <aside className='box' style={{display: position === 5 ? 'flex' : 'none'}}>
<StarInput setCallback={() => setPosition(state => state + 1)} placeholder="Linguagem clara e objetiva" name='p4'/>
</aside>
 
<aside className='box' style={{display: (position >= 6 && position <= 7) ? 'flex' : 'none'}}> 
<p style={{color: "#333", textAlign:'center', marginTop: '10px', marginBottom: '10px', fontWeight: 'bold'}}> 
1.3- Em relação ao palestrante Dr. Reinaldo Ramalho
            </p>
            </aside>
          
            <aside className='box' style={{display: position === 6 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} placeholder="Esclarecimentos de dúvidas" name='p5'/>
            </aside>

            <aside className='box' style={{display: position === 7 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} placeholder="Linguagem clara e objetiva" name='p6'/>
            </aside>

            <aside className='box' style={{display: position === 8 ? 'flex' : 'none'}}>
            <p style={{color: "#333", textAlign:'center', marginTop: '20px', marginBottom: '10px', fontWeight: 'bold'}}> 
            2 - Conteúdo
            </p>
            
            <StarInput setCallback={() => setPosition(state => state + 1)} name="p7" placeholder='Importância dos temas apresentados'/>
            </aside>

            <aside className='box' style={{display: (position >= 9 && position <= 14) ? 'flex' : 'none'}}> 
            <p style={{color: "#333", textAlign:'center', marginTop: '20px', marginBottom: '10px', fontWeight: 'bold'}}> 
            3 - Organização
            </p>
            </aside>
            <aside className='box' style={{display: position === 9 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} name="p8" placeholder='Qualidade dos equipamentos utilizados'/>
            </aside>
            <aside className='box' style={{display: position === 10 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} name="p9" placeholder='Local do evento (plataforma de streaming)'/>
            </aside>
            <aside className='box' style={{display: position === 11 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} name="p10" placeholder='Assistência durante o evento'/>
            </aside>
            <aside className='box' style={{display: position === 12 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} name="p11" placeholder='Carga horária em relação ao conteúdo'/>
            </aside>
            <aside className='box' style={{display: position === 13 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} name="p12" placeholder='Recursos do ambiente online (áudio, imagem, conexão, outros)'/>
            </aside>
            <aside className='box' style={{display: position === 14 ? 'flex' : 'none'}}>
            <StarInput setCallback={() => setPosition(state => state + 1)} name="p13" placeholder='Divulgação do evento'/>
            </aside>
            <aside className='box' style={{display: (position >= 15 && position <= 19) ? 'flex' : 'none'}}> 
            <p style={{color: "#333", textAlign:'center', marginTop: '20px', marginBottom: '10px', fontWeight: 'bold'}}> 
            4 - Avaliação geral
            </p>
</aside>
            <aside className='box' style={{display: position === 15 ? 'flex' : 'none'}}>
      
             <RangeInput setCallback={() => setPosition(state => state + 1)} name="p14" placeholder='Assinale uma nota de 1 a 10 para o evento:'/>
           
            </aside>
            <aside className='box' style={{display: position === 16 ? 'flex' : 'none'}}><p style={{color:'#333', marginBottom: '10px'}}>4.1 - Recomendaria este evento?</p>
            <SelectSimple options={[{label: 'Sim', value:'Sim', text:'Sim'},{label: 'Não', value:'Não', text:'Não'} ]}  name="p15" label=''/>
            <button className='defaultButton' onClick={() => setPosition(state => state + 1)} type='button'>CONTINUAR</button>
            </aside>
            <aside className='box' style={{display: position === 17 ? 'flex' : 'none'}}>
              <p style={{color: '#333', marginBottom: '10px'}}>4.2 - Pontos positivos do evento:</p>
            <TextareaInput name="p16" placeholder='Preencher'/>
            <button className='defaultButton' onClick={() => setPosition(state => state + 1)} type='button'>CONTINUAR</button>
            </aside>
            <aside className='box' style={{display: position === 18 ? 'flex' : 'none'}}>
            <p style={{color: '#333', marginBottom: '10px'}}>4.3 - Pontos que podem melhorar:</p>
            <TextareaInput name="p17" placeholder='Preencher'/>
            <button className='defaultButton' onClick={() => setPosition(state => state + 1)} type='button'>CONTINUAR</button>
            
            </aside>
            <aside className='box' style={{display: position === 19 ? 'flex' : 'none'}}>
            <p style={{color: '#333', marginBottom: '10px'}}>4.4 - Comentários e sugestões:</p>
            <TextareaInput name="p18" placeholder='Preencher'/>
            <button className='defaultButton' onClick={() => setPosition(state => state + 1)} type='button'>CONTINUAR</button>
            
            </aside>

            <aside className='box' style={{display: position === 20 ? 'flex' : 'none'}}>

          <h2 style={{color:'rgb(0, 153, 93)', textAlign: 'center',
    fontSize: '24px', marginBottom: '30px'}}>Obrigado por participar de nossa pesquisa.</h2>

            <button className='defaultButton' style={{ width: '200px', margin: '10px auto' }} type="submit">
              FINALIZAR
            </button>


            <br/> 
           <h2 style={{color: "#333", display:'flex', flexDirection:'column', marginTop:'30px', alignItems: 'center', justifyContent:'column'}} > Acesse nossos canais:  <br/><br/>
           <a href="https://www.unimed.coop.br/web/centralrs" style={{color:'rgb(0, 153, 93)'}}><FaLink size={15} style={{marginRight: '10px'}}/> Site</a> <br/>
 <a href="https://www.linkedin.com/company/unimed-central" style={{color:'rgb(0, 153, 93)'}}><FaLinkedin size={15} style={{marginRight: '10px'}}/>Linkedin</a> <br/>   

 
</h2>

<div style={{display:'flex', width: '100%', alignItems:'flex-start', justifyContent:'center', flexWrap:'wrap'}}>
 
 <div style={{padding:'15px', flexDirection:'column', display:'flex', margin: '10px', justifyContent:'flex-start', alignItems:'center'}}>
 <h2 style={{marginBottom:'15px', margin: '10px auto', color: 'rgb(43,152,97)'}}>Organização</h2>
   <img style={{width: '100%', maxWidth:'200px'}} src="/apoio/logo1.png"/>
 </div>

 <div style={{padding:'15px', flexDirection:'column', display:'flex', margin: '10px', justifyContent:'flex-start', alignItems:'center'}}>
 <h2 style={{marginBottom:'15px', margin: '10px auto', color: 'rgb(43,152,97)'}}>Apoio</h2>
   <img style={{width: '100%', maxWidth:'200px'}} src="/apoio/logo2.png"/>
 </div>
</div>
           <br/><br/>
            {errorMessage && (
              <Error>
                {errorMessage.map((item, index) => (
                  <div key={`error${index}`}>
                    <MdError />
                    {item}
                  </div>
                ))}
              </Error>
            )}
           

            <Sponsor/>
            </aside>

          </Form>
        
      </aside>
    </>
  );
};

export default FormContainer;
